import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalPaymentErrorService {

  constructor() { }

  GLOBALERRORHANDLE(ERROR_DATA: any) {
    const ERRORDATA = ERROR_DATA?.error;
    let errorMessage = ERRORDATA?.message || 'Something went wrong.';
    if (ERRORDATA?.errors && typeof ERRORDATA.errors === 'object') {
      const firstKey = Object.keys(ERRORDATA.errors)[0];
      const firstError = ERRORDATA.errors[firstKey];
        if (Array.isArray(firstError) && firstError.length > 0) {
        errorMessage = firstError[0];
      }
    }
    return errorMessage;
  }
}
